import type { DeploymentUnitResourceReadBffV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { DeviceChangeResourceApiByIdV2 } from '@ingenico/react-ui';
import { toString } from 'lodash-es';

export function mapDeviceChangeResourceApi(
  response: DeploymentUnitResourceReadBffV2Api,
): DeviceChangeResourceApiByIdV2 {
  return {
    options: {
      configuration: response.options.configuration
        ? {
            ...response.options.configuration,
            snapshotId: response.options.configuration.snapshotId,
            type: response.options.configuration?.type,
            custom: response.options.configuration?.custom
              ? {
                  ...response.options.configuration.custom,
                  definition: response.options.configuration.custom.definition,
                  description: response.options.configuration.custom.description,
                  name: toString(response.options.configuration.custom.name),
                }
              : undefined,
            reference: response.options.configuration?.reference,
          }
        : undefined,
      delete: response.options?.delete,
    },
    creationDate: response.creationDate,
    deploymentRequestId: response.deploymentRequestId,
    description: response.description,
    deviceId: response.deviceId,
    endDate: response.endDate,
    id: response.id,
    name: response.name,
    startDate: response.startDate,
    status: response.status,
    statusDetail: response.statusDetail,
    logicalDevice: response.logicalDevice,
    merchantId: response.merchantId,
    merchantName: response.merchantName,
    physicalDevice: response.physicalDevice as DeviceChangeResourceApiByIdV2['physicalDevice'],
  };
}
